module.exports = __webpack_public_path__ + "static/media/hospital.5242ef7e.jpg";